import BaseComponent from '@/components/base';
import { getStyle } from './style.js';

export default class MenuComponent extends BaseComponent {
  static get observedAttributes() {
    return ['menu-items'];
  }

  onConstruct() {
    this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
  }

  get linksHoverColor() {
    return this.getAttribute('links-hover-color');
  }

  get showMenuLinksBold() {
    return this.hasAttribute('show-menu-links-bold');
  }

  render() {
    const menuItems = this.state['menu-items'] || [];

    const activeItem =
      menuItems.find((item) => item.active) || menuItems[0] || {};
    const textLinks = activeItem.textLinks || [];
    const imageCards = activeItem.imageCards || [];

    let style = getStyle({
      isSmall: this.isSmall,
      linksHoverColor: this.linksHoverColor,
      showMenuLinksBold: this.showMenuLinksBold
    });

    if (this.isSmall) {
      return (
        style +
        `
      <div class="menu-tabs">
        ${menuItems
          .map(
            (item) => `
            <button
                class="tab-button ${item.active ? 'active' : ''}"
                data-label="${item.label}"
                data-haslinks="${item.textLinks.length > 0 ? 'true' : 'false'}"
                data-url="${item.link}"
            >
              ${item.label}
            </button>
          `
          )
          .join('')}
      </div>

      <div class="mobile-content">
        <div class="text-links-section">
          ${textLinks
            .map(
              (link) => `
              <a href="${link.link}">
                ${link.label}
                ${link.new ? '<span class="new-badge">NEW</span>' : ''}
              </a>
            `
            )
            .join('')}
        </div>


        ${
          this.showMobileImages && imageCards.length > 0
            ? `
          <div class="image-cards-section">
          ${
            imageCards.map(
              (card) => `
              <div class="card">
                <img src="${card.src}" alt="${card.alt}">
                <div class="p-4">
                  <p>${card.title}</p>
                </div>
                ${card.new ? '<span class="new-badge">NEW</span>' : ''}
              </div>
            `
            )[0]

            //.join('')
          }
        </div>
          `
            : ''
        }

      </div>
    `
      );
    }

    // ✅ DESKTOP VERSION (unchanged)
    return (
      style +
      `
    <div class="main-menu-container">
      <!-- Left Sidebar -->
      <div class="menu-sidebar">
        <ul>
          ${menuItems
            .map(
              (item) => `
              <li>
                <a
                    href="${item.link}"
                    class="${item.active ? 'active' : ''}"
                    data-label="${item.label}"
                    onclick="window.location.href='${item.link}';"
                >
                    ${item.label}
                </a>
              </li>
            `
            )
            .join('')}
        </ul>
      </div>

      <!-- Right Content Area -->
      <div class="menu-content">
        <div class="text-links-section">
          ${textLinks
            .map(
              (link) => `
              <a href="${link.link}">
                ${link.label}
                ${link.new ? '<span class="new-badge">NEW</span>' : ''}
              </a>
            `
            )
            .join('')}
        </div>

        <div class="image-cards-section">
          ${imageCards
            .map(
              (card) => `
              <div class="card" onclick="window.location.href='${card.link}';">
                <img src="${card.src}" alt="${card.alt}">
                <div class="p-4">
                  <p>${card.title}</p>
                </div>
                ${card.new ? '<span class="new-badge">NEW</span>' : ''}
              </div>
            `
            )
            .join('')}
        </div>
      </div>
    </div>
  `
    );
  }

  handleMenuItemClick(event) {
    console.log('handleMenuItemClick 888', event);
    event.preventDefault();

    const hasLinks = event.target.dataset.haslinks;
    const redirectUrl = event.target.dataset.url;

    if (hasLinks === 'false') {
      window.location.href = redirectUrl;
      return;
    }

    const clickedLabel = event.target.dataset.label;

    this.menuItems = (this.state['menu-items'] || []).map((item) => {
      return {
        ...item,
        active: item.label === clickedLabel
      };
    });
  }

  afterMount() {
    console.log('afterMount 888');
    if (this.isSmall) {
      const tabButtons = this.shadowRoot.querySelectorAll('.tab-button');
      tabButtons.forEach((btn) =>
        btn.addEventListener('click', this.handleMenuItemClick)
      );
    } else {
      const menuLinks = this.shadowRoot.querySelectorAll('.menu-sidebar a');
      menuLinks.forEach((link) => {
        setTimeout(() => {
          link.addEventListener('mouseenter', (e) => {
            const hoveredLabel = e.target.dataset.label;
            const updatedItems = this.menuItems.map((item) => ({
              ...item,
              active: item.label === hoveredLabel
            }));

            this.menuItems = updatedItems;
          });
        }, 20);

        setTimeout(() => {
          link.addEventListener('click', () => console.log('clicked kkk'));
        }, 10);
      });
    }
  }

  get menuItems() {
    return this.state['menu-items'] || [];
  }

  set menuItems(value) {
    this.setAttribute('menu-items', JSON.stringify(value));
  }

  get showMobileImages() {
    return this.hasAttribute('show-mobile-images');
  }
}
